"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pharmacy = void 0;
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
const ag_grid_react_1 = require("ag-grid-react");
const ui_1 = require("../../../../../../../../client/components/ui");
const store_1 = require("../../../../../../../../client/modules/reporting/store");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_1 = require("react");
const no_data_found_1 = require("../no-data-found/no-data-found");
const pharmacy_header_1 = require("./components/pharmacy-header");
const store_2 = require("../../../../../../../modules/sites/modules/sites-list/store");
const button_1 = require("../../../../../../../components/material/button");
const number_formatter_1 = require("../claim-analytics/number-formatter"); // E-037.31
const phone_number_formatter_1 = require("./components/phone-number-formatter");
const store_3 = require("../../../../../../../../client/modules/users/store"); // E-037.38
// E-037.34
var Day;
(function (Day) {
    Day["Monday"] = "monday";
    Day["Tuesday"] = "tuesday";
    Day["Wednesday"] = "wednesday";
    Day["Thursday"] = "thursday";
    Day["Friday"] = "friday";
    Day["Saturday"] = "saturday";
    Day["Sunday"] = "sunday";
})(Day || (Day = {}));
const dayOrder = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
};
let Pharmacy = class Pharmacy extends react_1.Component {
    constructor(props) {
        super(props);
        // Office hours.
        this.normalizeDay = (day) => {
            let normalizedDay = day;
            switch (day) {
                case Day.Monday: {
                    normalizedDay = "Mon";
                    break;
                }
                case Day.Tuesday: {
                    normalizedDay = "Tue";
                    break;
                }
                case Day.Wednesday: {
                    normalizedDay = "Wed";
                    break;
                }
                case Day.Thursday: {
                    normalizedDay = "Thu";
                    break;
                }
                case Day.Friday: {
                    normalizedDay = "Fri";
                    break;
                }
                case Day.Saturday: {
                    normalizedDay = "Sat";
                    break;
                }
                case Day.Sunday: {
                    normalizedDay = "Sun";
                    break;
                }
                default:
                    break;
            }
            return normalizedDay;
        };
        this.sortDayOrder = (a, b) => {
            const [keyA] = a;
            const [keyB] = b;
            return dayOrder[keyA] - dayOrder[keyB];
        };
        // E-037.34
        this.renderDisplayHours = (params) => {
            var _a;
            const officeHours = params.data.clinicHours;
            return (React.createElement("div", { style: { display: "flex" } }, (_a = Object === null || Object === void 0 ? void 0 : Object.entries(officeHours)) === null || _a === void 0 ? void 0 : _a.sort(this.sortDayOrder).map(([day, details]) => {
                const { open, hours } = details;
                return (React.createElement("div", { key: day },
                    day.charAt(0).toUpperCase() + day.slice(1, 3),
                    ":",
                    " ",
                    open ? null : "Closed",
                    open &&
                        hours
                            .map((hour) => `${hour.from} - ${hour.to}`)
                            .join(","),
                    "\u00A0"));
            })));
        };
        // Update Service Fee Column
        this.customeServiceFee = ({ data }) => {
            const value = Number(data.imbFee);
            let text = value.toLocaleString(undefined, {
                style: "currency",
                currency: "USD",
            });
            if (data.feeType === "Percent") {
                text = `${value}%`;
            }
            else {
                if (text === "$NaN" || !value) {
                    text = "";
                    if (value === 0) {
                        text = "$0.00";
                    }
                }
            }
            return text;
        };
        // C-117.1_PROD
        // private onButtonExport = () => {
        //   const params = {
        //     fileName: "Pharmacy_Detailed_Spreadsheet.csv",
        //   };
        //   this.storeData.gridApi.exportDataAsCsv(params);
        // };
        this.onButtonExport = () => {
            const selectedRows = this.storeData.gridApi.getSelectedRows(); // Get selected rows
            const params = {
                fileName: "Pharmacy_Selected_Rows.csv",
                onlySelected: true // This will ensure only selected rows are exported
            };
            this.storeData.gridApi.exportDataAsCsv(params);
        };
        this.storeData = {
            defaultColDef: {
                enablePivot: true,
                enableRowGroup: true,
                enableValue: true,
                sortable: true,
                resizable: true,
                filter: true,
                comparator(a, b) {
                    if (typeof a === "string") {
                        return a.localeCompare(b);
                    }
                    return a > b ? 1 : a < b ? -1 : 0;
                },
            },
            columnDefs: [
                {
                    headerName: "Legal Name",
                    field: "name",
                    enableRowGroup: true,
                    headerCheckboxSelection: true,
                    checkboxSelection: true,
                },
                {
                    headerName: "Display Name",
                    field: "displayName",
                    enableRowGroup: true,
                },
                {
                    headerName: "Doing Business As",
                    field: "dba",
                    enableRowGroup: true,
                },
                {
                    headerName: "Address",
                    field: "address",
                },
                {
                    headerName: "City",
                    field: "city",
                },
                {
                    headerName: "State",
                    field: "state",
                },
                {
                    headerName: "Zip",
                    field: "zip",
                },
                {
                    headerName: "Phone",
                    field: "phone",
                    cellRenderer: "phoneNumberFormatter",
                },
                {
                    headerName: "Ext (Phone)",
                    field: "phoneExt",
                },
                {
                    headerName: "Fax",
                    field: "fax",
                    cellRenderer: "faxNumberFormatter",
                },
                {
                    headerName: "Website",
                    field: "website",
                },
                {
                    headerName: "Timezone",
                    field: "timezone",
                },
                {
                    headerName: "Office Hours",
                    width: 200,
                    field: "clinicHours",
                },
                {
                    headerName: "Tax ID",
                    field: "taxId",
                },
                {
                    headerName: "NCPDP ID",
                    field: "ncpdpId",
                },
                {
                    headerName: "NPI Number",
                    field: "npiNumber",
                },
                {
                    headerName: "DEA License",
                    field: "deaLicense",
                },
                {
                    headerName: "Notes",
                    field: "notes",
                },
                {
                    headerName: "Fee Type",
                    field: "feeType",
                },
                {
                    headerName: "Service Fee",
                    field: "imbFee",
                    filter: "agNumberColumnFilter",
                    type: "numericColumn",
                },
                {
                    headerName: "Trans Fee",
                    field: "transactionFee",
                    filter: "agNumberColumnFilter",
                    type: "numericColumn",
                },
                {
                    headerName: "Max Copay",
                    field: "maxCopay",
                    filter: "agNumberColumnFilter",
                    type: "numericColumn",
                },
                {
                    headerName: "Min Prof",
                    field: "minProfit",
                    filter: "agNumberColumnFilter",
                    type: "numericColumn",
                },
            ],
            clinicOfficeHours: [],
            rowSelection: "multiple",
            rowData: [],
            multiSortKey: "ctrl",
            floatingFilter: true,
            frameworkComponents: {
                numberFormatter: number_formatter_1.NumberFormatter,
                serciceFeeType: this.customeServiceFee,
                phoneNumberFormatter: phone_number_formatter_1.PhoneNumberFormatter,
                faxNumberFormatter: phone_number_formatter_1.PhoneNumberFormatter
            },
        };
    }
    async componentDidMount() {
        // await sitesListStore.loadSitesNoRelation(); // E-037.1
        await store_2.sitesListStore.loadAllSitesNoRelation(); // C-117_UAT
    }
    componentWillUnmount() {
        // sitesListStore.sites.value = null; // E-037.1  // figured out: when we go to the dashbaord in breaks (so removed it)
    }
    // E-037.3111
    renderImbFee(val, feeType) {
        const value = Number(val);
        let text = value === null || value === void 0 ? void 0 : value.toLocaleString(undefined, {
            style: "currency",
            currency: "USD",
        });
        if (feeType === "percent") {
            text = `${value}%`;
        }
        else {
            if (text === "$NaN" || !value) {
                text = "";
                if (value === 0) {
                    text = "$0.00";
                }
            }
        }
        return text;
    }
    // E-037.3111
    accountingFormat(data) {
        const value = Number(data);
        let text = value.toLocaleString(undefined, {
            style: "currency",
            currency: "USD"
        });
        if (text === "$NaN" || !value) {
            text = "";
            if (value === 0) {
                text = "$0.00";
            }
        }
        return text;
    }
    renderClinicHours(clinics) {
        clinics === null || clinics === void 0 ? void 0 : clinics.forEach((clinic) => {
            const { clinicHours } = clinic;
            let hoursString = "";
            // C-117_UAT
            if (!clinicHours || typeof clinicHours !== "object") {
                // Skip if clinicHours is missing or not an object
                return;
            }
            for (const [day, detail] of Object === null || Object === void 0 ? void 0 : Object.entries(clinicHours).sort(this.sortDayOrder)) {
                const { open, hours } = detail;
                if (open) {
                    hoursString += `${day.charAt(0).toUpperCase() + day.slice(1, 3)}: `;
                    hours.forEach((hour) => {
                        hoursString += `${hour.from} - ${hour.to}, `;
                    });
                }
                else {
                    hoursString += `${day.charAt(0).toUpperCase() + day.slice(1, 3)}: Closed `;
                }
            }
            this.storeData.clinicOfficeHours.push(hoursString);
        });
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        // E-037.11
        const phoneNumberFormat = (number) => {
            return number === null || number === void 0 ? void 0 : number.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        };
        // E-037.38
        if (!store_3.usersStore.permissions.ReadPharmacyReport) {
            return store_3.usersStore === null || store_3.usersStore === void 0 ? void 0 : store_3.usersStore.showLock();
        }
        const loadingData = store_1.reportsStore.showLoader;
        const storeData = (_a = store_2.sitesListStore.sites) === null || _a === void 0 ? void 0 : _a.value;
        this.storeData.rowData = storeData;
        this.renderClinicHours(this.storeData.rowData);
        const transformedData = (_b = this.storeData.rowData) === null || _b === void 0 ? void 0 : _b.map((val, i) => {
            var _a, _b;
            return (Object.assign(Object.assign({}, val), { zip: '\u200B' + val.zip, fax: phoneNumberFormat(val.fax), phone: phoneNumberFormat(val.phone), feeType: ((_a = val.feeType) === null || _a === void 0 ? void 0 : _a.charAt(0).toUpperCase()) + val.feeType.slice(1, (_b = val === null || val === void 0 ? void 0 : val.feeType) === null || _b === void 0 ? void 0 : _b.length), clinicHours: this.storeData.clinicOfficeHours[i], 
                // E-037.3111 accounting format 
                imbFee: this.renderImbFee(val.imbFee, val.feeType), transactionFee: this.accountingFormat(val.transactionFee), maxCopay: this.accountingFormat(val.maxCopay), minProfit: this.accountingFormat(val.minProfit) }));
        });
        // User permission // E-037.38
        const devAdmin = ((_d = (_c = store_3.usersStore.user) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.groupId) === 1 || ((_f = (_e = store_3.usersStore.user) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.groupId) === 4;
        const user = ((_h = (_g = store_3.usersStore.user) === null || _g === void 0 ? void 0 : _g.value) === null || _h === void 0 ? void 0 : _h.sites) || [];
        const assignedSiteLists = transformedData === null || transformedData === void 0 ? void 0 : transformedData.filter((site) => user.includes(site === null || site === void 0 ? void 0 : site.id));
        console.log("assignedSiteLists", assignedSiteLists);
        if (storeData && storeData.length > 0) {
            return (React.createElement(React.Fragment, null,
                React.createElement(pharmacy_header_1.PharmacyHeader, { title: "Pharmacy", withDatePicker: true }),
                React.createElement("div", { className: "ag-theme-balham", style: {
                        height: "85%",
                        width: "100%",
                    } },
                    React.createElement(button_1.MaterialButton, { className: "secondary", onClick: this.onButtonExport.bind(this) }, "Export to CSV"),
                    React.createElement(ag_grid_react_1.AgGridReact, { onGridReady: (params) => (this.storeData.gridApi = params.api), rowSelection: this.storeData.rowSelection, columnDefs: this.storeData.columnDefs, defaultColDef: this.storeData.defaultColDef, frameworkComponents: this.storeData.frameworkComponents, multiSortKey: this.storeData.multiSortKey, animateRows: true, sideBar: true, groupMultiAutoColumn: true, floatingFilter: this.storeData.floatingFilter, suppressExcelExport: true, rowData: devAdmin ? transformedData : assignedSiteLists }))));
        }
        if (storeData) {
            if (loadingData) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(pharmacy_header_1.PharmacyHeader, { title: "Pharmacy", withDatePicker: true }),
                    React.createElement("div", null, "Loading Data...")));
            }
            // Return a Custom built component here to handle 0 data returned.
            return (React.createElement(no_data_found_1.default, { headerComponent: React.createElement(pharmacy_header_1.PharmacyHeader, { title: "Pharmacy", withDatePicker: true }) }));
        }
        return React.createElement(ui_1.UiLoadingIndicator, null);
    }
};
Pharmacy = __decorate([
    mobx_react_1.observer
], Pharmacy);
exports.Pharmacy = Pharmacy;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/pharmacy/pharmacy.tsx
// module id = 3984
// module chunks = 0